import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResizableTh from '../ResizableTh';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from '../../redux/store';
import { setSelectedRow } from '../../redux/slices/rowhighlight';
import '../../Pages/Projects/ProjectList/ProjectList.css';

function ClientListTable(props) {
  const [columnWidths, setColumnWidths] = React.useState({
    0: 70,   // ID
    1: 40,   // Type
    2: 150,  // Name
    3: 140,  // Tags
    4: 110,  // Promoted Projects
    5: 80,   // Follow Up
    6: 50,   // Win-rate
    7: 140,  // Preferred
    8: 200,  // Email Address
    9: 140,  // Phone Number
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
  };

  const tableRef = React.useRef(); // Create a ref for the table
  const [hoveredRow, setHoveredRow] = React.useState(null);
  const selectedRow = useSelector((state) => state.rowhighlight.selectedRow);
  const tagsFilter = useSelector((state) => state.client.tagsFilter);

  const setColumnWidth = React.useCallback((index, width) => {
    setColumnWidths((prev) => {
      const totalWidth = Object.values(prev).reduce((a, b) => a + b, 0);
      const tableWidth = tableRef.current ? tableRef.current.offsetWidth : 0;

      if (prev[index] !== width && totalWidth - prev[index] + width <= tableWidth) {
        const newWidths = { ...prev };
        newWidths[index] = width;
        return newWidths;
      }

      if (totalWidth - prev[index] + width > tableWidth) {
        const newWidths = { ...prev };
        newWidths[index] = width;
        const excessWidth = totalWidth - prev[index] + width - tableWidth;
        const otherColumns = Object.keys(newWidths).filter((key) => key !== index);
        let remainingExcessWidth = excessWidth;

        const shrinkLeft = index > 0 && index < otherColumns.length;
        const sortedColumns = shrinkLeft ? otherColumns.sort((a, b) => a - b) : otherColumns.sort((a, b) => b - a);

        for (const column of sortedColumns) {
          if (newWidths[column] > 50 + remainingExcessWidth / otherColumns.length) {
            newWidths[column] -= remainingExcessWidth / otherColumns.length;
            remainingExcessWidth -= remainingExcessWidth / otherColumns.length;
          } else {
            remainingExcessWidth -= newWidths[column] - 50;
            newWidths[column] = 50;
          }
        }

        return newWidths;
      }

      return prev;
    });
  }, []);

  React.useEffect(() => {
    const scrollPos = localStorage.getItem('scrollPos');
    if (scrollPos && tableRef.current) {
      tableRef.current.scrollTop = parseFloat(scrollPos);
    }
    console.log(props.rows);
  }, []);

  const handleRowClick = (row) => {
    navigate(`ClientProfile#${row.id}`);
  };

  const getSortKey = (header) => {
    switch (header) {
      case 'Promoted Projects':
        return 'promoted_projects';
      case 'Win-rate':
        return 'winrate';
      default:
        return header.toLowerCase().replace(/[ .]/g, '');
    }
  };

  const uniqueRows = React.useMemo(() => {
    const invNumSet = new Set();
    return props.rows.filter(row => {
      console.log(props.rows)
      if (invNumSet.has(row.id)) {
        return false;
      } else {
        invNumSet.add(row.id);
        return true;
      }
    });
  }, [props.rows]);

  // Build dynamic headers depending on POI filter
  // Always include Follow Up column
  const headers = ['ID', 'Type', 'Name', 'Tags', 'Promoted Projects', 'Follow Up', 'Win-rate', 'Preferred', 'Email Address', 'Phone Number'];

  return (
    <div className='ProjectListBox'>
      <div id="clientTableContainer" ref={tableRef}>
        <table>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <ResizableTh onResize={(width) => setColumnWidth(index, width)} index={index} key={header}>
                  <span
                    onClick={props.loading ? null : () => props.handleSort(getSortKey(header))}
                    className={props.loading ? 'disable-click' : ''}>
                    {header}
                    {props.sortColumn === getSortKey(header) && (
                      props.sortDirection === 'asc' ? ' ▲' : ' ▼'
                    )}
                  </span>
                </ResizableTh>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.loading ? (
              [...Array(50)].map((_, index) => (
                <tr key={index}>
                  {headers.map((_, cellIndex) => (
                    <td key={cellIndex} style={{ width: columnWidths[cellIndex] || 120 }}>
                      <div className="skeleton" style={{ height: '13px' }}></div>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              uniqueRows.map((row) => (
                <tr
                  key={row.id}
                  onMouseEnter={() => setHoveredRow(row.id)}
                  onMouseLeave={() => setHoveredRow(null)}
                  onClick={() => {
                    handleRowClick(row);
                    dispatch(setSelectedRow(row.id));
                    if (tableRef.current) {
                      localStorage.setItem('scrollPos', tableRef.current.scrollTop);
                    }
                  }}
                  className={`
                  ${hoveredRow === row.id && selectedRow !== row.id ? 'row-hover' : ''}
                  ${selectedRow === row.id ? 'row-selected' : ''}
                `}
                >
                  <td style={{ width: columnWidths[0], maxWidth: '70px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '50px', textAlign: 'center' }}>{row.id}</div>
                    </Link>
                  </td>

                  <td style={{ width: columnWidths[1], maxWidth: '100px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '40px', width: `${columnWidths[1]}px`, maxWidth: '100px' }}>{row.type === 'Person of Interest' ? 'POI' : row.type}</div>
                    </Link>
                  </td>

                  <td style={{ width: columnWidths[2], maxWidth: '320px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '130px', width: `${columnWidths[2]}px`, maxWidth: '320px' }}>{row.name}</div>
                    </Link>
                  </td>

                  {/* Tags */}
                  <td style={{ width: columnWidths[3], maxWidth: '220px', textAlign: 'center' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ display: 'flex', minWidth: '20px', justifyContent: 'center' }}>
                        {(() => {
                          const raw = row.tags;
                          const tagArray = Array.isArray(raw)
                            ? raw
                            : (typeof raw === 'string' && raw.trim().length > 0)
                              ? raw.split(',').map((t) => t.trim()).filter(Boolean)
                              : [];
                          // Only show tags when they're exactly 'Person of Interest'
                          const poiTags = tagArray.filter((t) => t === 'Person of Interest');
                          return poiTags.length > 0 ? (
                            <div className="TagContainer">
                              {poiTags.slice(0, 3).map((tag) => (
                                <div key={tag} className="Tag">POI</div>
                              ))}
                            </div>
                          ) : null;
                        })()}
                      </div>
                    </Link>
                  </td>

                  {/* Promoted Projects */}
                  <td style={{ width: columnWidths[4], maxWidth: '120px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '60px', width: `${columnWidths[4]}px`, maxWidth: '120px' }}>{row.promoted_projects ? row.promoted_projects : ''}</div>
                    </Link>
                  </td>

                  {/* Follow Up (always shown) */}
                  <td style={{ width: columnWidths[5] || 80, maxWidth: '120px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '70px', width: columnWidths[5] || 80, maxWidth: '120px' }}>{row.follow_up || row.followup || ''}</div>
                    </Link>
                  </td>

                  {/* Win-rate: right aligned and rounded to nearest percent */}
                  <td style={{ width: columnWidths[6], maxWidth: '50px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '50px', width: `${columnWidths[6]}px`, maxWidth: '50px', textAlign: 'right' }}>
                        {(() => {
                          const value = row.win_rate;
                          if (value === null || value === undefined || value === '') return '';
                          // parse numeric value, handle percentages or plain numbers
                          const num = typeof value === 'number' ? value : parseFloat(String(value).replace('%', ''));
                          if (isNaN(num)) return String(value);
                          const rounded = Math.round(num);
                          return `${rounded}%`;
                        })()}
                      </div>
                    </Link>
                  </td>

                  {/* Preferred */}
                  <td style={{ width: columnWidths[7], maxWidth: '160px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '100px', width: `${columnWidths[7]}px`, maxWidth: '160px' }}>{row.preferred}</div>
                    </Link>
                  </td>

                  {/* Email */}
                  <td style={{ width: columnWidths[8], maxWidth: '220px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '140px', width: `${columnWidths[8]}px`, maxWidth: '220px' }}>{row.email}</div>
                    </Link>
                  </td>

                  {/* Phone Number */}
                  <td style={{ width: columnWidths[9], maxWidth: '160px' }}>
                    <Link to={() => handleRowClick(row)} style={linkStyle}>
                      <div className="td-content" style={{ minWidth: '100px', width: columnWidths[9], maxWidth: '160px' }}>{row.phone_number}</div>
                    </Link>
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ClientListTable;